import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { StorungenComponent } from './storungen.component';
import { AvaconStorungenComponent } from './avacon-storungen/avacon-storungen.component';
import { BayernwerkStorungenComponent } from './bayernwerk-storungen/bayernwerk-storungen.component';
import { HansewerkStorungenComponent } from './hansewerk-storungen/hansewerk-storungen.component';
import { LechwerkeStorungenComponent } from './lechwerke-storungen/lechwerke-storungen.component';
import { EnviamStorungenComponent } from './enviam-storungen/enviam-storungen.component';
import { WestenergieStorungenComponent } from './westenergie-storungen/westenergie-storungen.component';
import { EdisStorungenComponent } from './edis-storungen/edis-storungen.component';

@NgModule({
  declarations: [
    StorungenComponent,
    AvaconStorungenComponent,
    BayernwerkStorungenComponent,
    HansewerkStorungenComponent,
    LechwerkeStorungenComponent,
    EnviamStorungenComponent,
    WestenergieStorungenComponent,
    EdisStorungenComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class StorungenModule {}
